import React, { useState } from "react";
import "./LoginPage.css";
import StudentLogin from "./StudentLogin";
import TeacherLogin from "./TeacherLogin";

const LoginPage = () => {
  const [active, setActive] = useState("SecondCard");
  return (
    <div className="bg-green-50 h-screen">
      <div className="mx-auto justify-between lg:w-[70%] md:w-[90%] sm:w-[95%]  py-8 flex flex-row">
        <div className="flex justify-start items-center">
          <img
            className="w-[500px] transform scale-x-[-1]"
            src="https://i.ibb.co/WtNV8TF/man-reading-laptop.png"
            alt=""
          ></img>
        </div>
        <div className="flex justify-start items-start flex-col w-[50%] ">
          <div className="flex flex-col justify-start items-center ">
            <h1 className="text-start text-4xl text-green-800   font-montserrat w-full">
              Welcome Back
            </h1>
            <h1 className="text-start text-xl mt-5 text-green-800   font-montserrat w-full">
              Sign In to Continue
            </h1>

            <div className="flex flex-row justify-start items-start w-full mt-5">
              <div className="flex items-center gap-10">
                <button
                  onClick={() => setActive("FirstCard")}
                  className={
                    active === "FirstCard"
                      ? "font-montserrat text-start space-x-0 text-2xl text-green-900 rounded-full border-2 shadow-lg border-green-900 px-10 py-3 bg-green-200" // This is the class applied when active is "FirstCard"
                      : "font-montserrat bg-white shadow-xl space-x-0 text-2xl text-green-900 rounded-full border border-green-900 px-10 py-3"
                  }
                >
                  <div className="flex flex-col justify-center items-center">
                    <h1>Student/Guardian</h1>
                    <p className="text-sm font-jost">
                      Select, if you looking for a tutor
                    </p>
                  </div>
                </button>
                <button
                  onClick={() => setActive("SecondCard")}
                  className={
                    active === "SecondCard"
                      ? "font-montserrat text-start space-x-0 text-2xl text-green-900 rounded-full border-2 shadow-lg border-green-900 px-10 py-3 bg-green-200" // This is the class applied when active is "FirstCard"
                      : "font-montserrat space-x-0 bg-white shadow-xl text-2xl text-green-900 rounded-full border border-green-900 px-10 py-3"
                  }
                >
                  <div className="flex flex-col justify-start w-full items-center">
                    <h1>Tutor</h1>
                    <p className="text-sm font-jost">
                      Select, if you looking for a tuition job
                    </p>
                  </div>
                </button>
                {/* <input
                            checked={active === "FirstCard"}
                            onChange={() => setActive("FirstCard")}
                            id="horizontal-list-radio-license"
                            type="radio"
                            value=""
                            name="list-radio"
                            className="w-4 h-4 radioColor text-blue-600 bg-gray-100 border-gray-300 focus:ring-orange-500 dark:focus:ring-orange-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        />
                        <label htmlFor="horizontal-list-radio-license" className="w-full py-3 ml-2  dark:text-gray-300 radioText">Student/Guardian</label> */}
              </div>
            </div>

            <div className="mt-10 py-5">
              {active === "FirstCard" && <StudentLogin title="1" />}
              {active === "SecondCard" && <TeacherLogin title="2" />}
            </div>
          </div>
        </div>
      </div>
      {/* <div className='flex flex-col justify-center items-center'>
                <div className='flex lg:flex-row sm:flex-col justify-between lg:items-center lg:w-[664px] mt-10 px-10'>
                 <div className="flex items-center pl-3">
                        <input
                            checked={active === "FirstCard"}
                            onChange={() => setActive("FirstCard")}
                            id="horizontal-list-radio-license"
                            type="radio"
                            value=""
                            name="list-radio"
                            className="w-4 h-4 radioColor text-blue-600 bg-gray-100 border-gray-300 focus:ring-orange-500 dark:focus:ring-orange-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        />
                        <label htmlFor="horizontal-list-radio-license" className="w-full py-3 ml-2  dark:text-gray-300 radioText">Student/Guardian</label>
                    </div>
                    <div className="flex items-center pl-3">
                        <input
                            checked={active === "SecondCard"}
                            onChange={() => setActive("SecondCard")}
                            id="horizontal-list-radio-id"
                            type="radio"
                            value=""
                            name="list-radio"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 radioColor focus:ring-orange-500 dark:focus:ring-orange-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        />
                        <label htmlFor="horizontal-list-radio-id" className="w-full py-3 ml-2 radioText dark:text-gray-300">Tutor</label>
                    </div>
                </div>

                <div className='mt-10 p-5'>
                    {active === "FirstCard" && <StudentLogin title="1" />}
                    {active === "SecondCard" && <TeacherLogin title="2" />}

                </div>
            </div> */}
    </div>
  );
};

export default LoginPage;
